// extracted by mini-css-extract-plugin
module.exports = {"commentItem":"CommentItem_commentItem__1_COj","author":"CommentItem_author__3iX01","text":"CommentItem_text__1Jeqj"};